package net.sergeych.kilogin

import kotlinx.datetime.Clock
import kotlinx.serialization.KSerializer
import kotlinx.serialization.serializer
import net.sergeych.bintools.toDataSource
import net.sergeych.bipack.BipackDecoder
import net.sergeych.bipack.BipackEncoder
import net.sergeych.crypto2.blake2b
import net.sergeych.crypto2.randomUBytes
import net.sergeych.kiloparsec.encodeToUByteArray


fun <T>biDecode(serializer: KSerializer<T>,data: UByteArray): T =
    BipackDecoder.decode(data.toDataSource(), serializer)

@Suppress("unused")
fun <T>biDecode(serializer: KSerializer<T>, data: ByteArray): T =
    BipackDecoder.decode(data.toDataSource(), serializer)

@Suppress("unused")
inline fun <reified T>biDecode(data: ByteArray): T =
    BipackDecoder.decode(data)

inline fun <reified T>biDecode(data: UByteArray): T =
    BipackDecoder.decode(data.toByteArray())

fun randomBytes(size: Int): ByteArray =
    randomUBytes(size).toByteArray()

@Suppress("unused")
fun <T>biEncode(serializer: KSerializer<T>,data: T): UByteArray = BipackEncoder.encode(serializer, data).asUByteArray()
inline fun <reified T>biEncode(data: T): UByteArray = BipackEncoder.encode(serializer<T>(), data).asUByteArray()

@Suppress("unused")
fun defaultHash(text: String) = blake2b(text.encodeToUByteArray())

//@Suppress("unused")
//fun ByteArray.toChunk() = ByteChunk(this.asUByteArray())
//fun UByteArray.toChunk() = ByteChunk(this)

fun <T>bm(name: String, f: ()->T):T {
    val start = Clock.System.now()
    return f().also {
        println("*** BM: $name took ${Clock.System.now() - start} ms")
    }
}
